import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { useT } from "@/lib/i18n";
import { trackEvent } from "@/lib/analytics";

export default function Footer() {
  const t = useT();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-[#2A2A2A] py-14">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-3">
            <span className="font-serif-display text-3xl text-[#F5F5F0] tracking-tight">{BRAND.name}</span>
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">{t.brand.studio}</span>
          </div>
          <p className="mt-4 text-[#A3A3A3] max-w-md leading-relaxed">{t.brand.tagline}</p>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-4">{t.footer.reach}</div>
          <a href={BRAND.phoneHref} data-testid="footer-phone" onClick={() => trackEvent("call_click", { source: "footer" })} className="flex items-center gap-2 text-[#F5F5F0] hover:text-[#D4AF37] transition">
            <Phone className="w-4 h-4" /> {BRAND.phone}
          </a>
          <a href={BRAND.emailHref} data-testid="footer-email" onClick={() => trackEvent("email_click", { source: "footer" })} className="flex items-center gap-2 mt-2 text-[#F5F5F0] hover:text-[#D4AF37] transition">
            <Mail className="w-4 h-4" /> {BRAND.email}
          </a>
        </div>
        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-4">{t.footer.studio}</div>
          <p className="text-[#F5F5F0]">{BRAND.hours}</p>
          <a
            href={BRAND.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-address-link"
            onClick={() => trackEvent("maps_click", { source: "footer" })}
            className="inline-flex items-center gap-2 text-[#A3A3A3] text-sm mt-2 hover:text-[#D4AF37] transition"
          >
            <MapPin className="w-3.5 h-3.5" />
            <span>{BRAND.address}</span>
          </a>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-10 pt-6 border-t border-[#2A2A2A] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <p className="text-xs text-[#A3A3A3]">© {new Date().getFullYear()} {BRAND.name} · {t.brand.studio}. {t.footer.rights}</p>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">{t.footer.crafted}</p>
      </div>
    </footer>
  );
}
